// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — форма ячейки со строками и правкой)
// Форма ячейки шахматки (Dropdown «РЯДОК: … КОМІРКА: …», её открывает вложенный AttrGrid — AttrGrid.dropdown_prepare): вкладки «Рядок» — строка плоской таблицы
// cell_table_binding для пары (узел × поле / горизонт / узел-цель ребра), «Вузол» — строка rows_binding, «Колонка» — строка columns_binding. У вкладки — поля из колонок
// её грида на форме (cell_grid_name / rows_grid_name / columns_grid_name; нет имени — грид по binding таблицы) с текущими значениями; правка — карточкой строки
// widget-row (как AttrGraph.openRowWidget / граф схемы p032): поля пишутся в запись по binding.iroot.поле, Save общий, отмена — как у Save; шахматка и гриды перерисовываются сами.
// Пустая ячейка (строки плоской таблицы нет) — вкладка «Рядок» неактивна с пояснением: строку создаёт сама ячейка (значение в ячейке → строка с cell_create_defaults,
// откат — Ctrl+Z грида), второго пути создания нет. Вложенный режим (ячейки внутри строк rows_binding, плоской таблицы нет) — вкладки «Рядок» нет.
// Выключатель fe.ux.crossGridRowCards (дефолт ВКЛ; выкл — форма ячейки как прежде). Чистая логика (без Vue, DOM и стора). Юнит-тест: node --test tests/unit/crossGridRowCards.test.mjs
import { getPath, localized, findCellRow, valueId } from './crossGrid'
import { cg2FindGrid, cg2TableTitle } from './crossGridV2'
import { rlConfig, rlItems, rlShown, RL_TYPE } from './rowLink'   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040)

export const CG_FLAG_ROWCARDS = 'fe.ux.crossGridRowCards'
export function crossGridRowCardsOn(setting) {
    try { return (typeof setting === 'function' ? setting(CG_FLAG_ROWCARDS, true) : true) !== false } catch (e) { return true }
}
// порядок вкладок и их подписи (ключи перевода — по-английски: Row / Node / Column)
export const CG_CARD_KEYS = ['row', 'node', 'column']
export const CG_CARD_TITLES = Object.freeze({ row: 'Row', node: 'Node', column: 'Column' })
export const CG_CARD_MAX_FIELDS = 16
export const CG_CARD_TEXT_MAX = 120

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const hasKey = (k) => k !== undefined && k !== null && k !== ''
const arr = (v) => (Array.isArray(v) ? v : [])

// cgColSource: строка таблицы колонок с ключом key (в любой глубине children_path; дубль ключа — первая, как у листа шахматки)
export function cgColSource(colRows, key, cfg) {
    if (!hasKey(key) || !cfg) return null
    const k = String(key)
    const walk = (rows) => {
        for (const r of arr(rows)) {
            if (!isObj(r)) continue
            const rk = getPath(r, cfg.key_binding)
            if (hasKey(rk) && String(rk) === k) return r
            const f = walk(r[cfg.children_path])
            if (f) return f
        }
        return null
    }
    return walk(colRows)
}

// cgCardTargets: три строки по ячейке шахматки. src — живая строка источника (rows_binding) строки проекции, vm — строка проекции, leaf — лист колонки (null — колонка заголовков),
// cols — таблица колонок, c2 — параметры v2 (имена гридов). → { row?, node, column }: { key, binding, grid, children, row (строка или null), reason }
// reason: '' — строка есть; 'empty' — у пары нет строки плоской таблицы; 'nokey' — у строки или колонки шахматки нет ключа; 'title' — колонка заголовков (ячейки нет); 'gone' — строки нет в таблице
export function cgCardTargets({ src, vm, leaf, cfg, cols, c2 } = {}) {
    if (!cfg) return null
    const g = isObj(c2) ? c2 : {}
    const out = {}
    if (cfg.flat) {
        let row = null, reason = ''
        if (!leaf) reason = 'title'
        else if (!isObj(src) || !hasKey(getPath(src, cfg.key_binding)) || !hasKey(leaf.key) || (vm && vm.cg_key === null)) reason = 'nokey'
        else { row = findCellRow(src, leaf.key, cfg).row || null; if (!row) reason = 'empty' }
        out.row = { key: 'row', binding: cfg.cell_table_binding, grid: g.cell_grid || '', children: '', row, reason }
    }
    out.node = { key: 'node', binding: cfg.rows_binding, grid: g.rows_grid || '', children: cfg.children_path, row: isObj(src) ? src : null, reason: isObj(src) ? '' : 'gone' }
    let col = null, cr = 'title'
    if (leaf) { col = hasKey(leaf.key) ? cgColSource(cols, leaf.key, cfg) : null; cr = col ? '' : (hasKey(leaf.key) ? 'gone' : 'nokey') }
    out.column = { key: 'column', binding: cfg.columns_binding, grid: g.columns_grid || '', children: cfg.children_path, row: col, reason: cr }
    return out
}

// cgGridColumns: листовые колонки описания грида по порядку (группы колонок раскрыты); без binding, служебные («_…», «cg_…») и скрытые (visible false / hidden) — пропускаются
export function cgGridColumns(gridDecl) {
    const out = []
    const walk = (list) => {
        for (const n of arr(list)) {
            if (!isObj(n)) continue
            if (Array.isArray(n.attrs) && n.attrs.length && !n.binding) { walk(n.attrs); continue }
            const b = typeof n.binding === 'string' ? n.binding : ''
            if (!b || b.startsWith('_') || b.startsWith('cg_') || n.visible === false || n.hidden === true) continue
            out.push(n)
        }
    }
    walk(gridDecl && gridDecl.attrs)
    return out
}

const cut = (s) => (s.length > CG_CARD_TEXT_MAX ? s.slice(0, CG_CARD_TEXT_MAX - 1) + '…' : s)
// cgFieldText: значение поля строки для показа: флажок — ✓ / —; перечисление колонки (itemsSource) — подпись на языке пользователя; ссылка — подпись из словаря (lookup(сегмент, id)),
// объект — title / valueStr / name / id; массив — через запятую; пусто — ''. Длинное — «…»
export function cgFieldText(v, col, lang, t, lookup) {
    const tr = typeof t === 'function' ? t : (s) => s
    const one = (x) => {
        if (x === undefined || x === null || x === '') return ''
        if (typeof x === 'boolean') return x ? '✓' : '—'
        const id = valueId(x)
        const items = col && Array.isArray(col.itemsSource) ? col.itemsSource : null
        if (items && hasKey(id)) {
            const it = items.find((e) => isObj(e) && String(e.id) === String(id))
            if (it) { const own = lang ? it[`title_${lang}`] : ''; return String((typeof own === 'string' && own) || (it.title ? tr(String(it.title)) : it.id)) }
        }
        const seg = col && typeof col.relation_segment === 'string' ? col.relation_segment : ''
        if (seg && hasKey(id) && typeof lookup === 'function') { const s = lookup(seg, id); if (s) return String(s) }
        if (isObj(x)) { const s = x.title ?? x.valueStr ?? x.name ?? x.id ?? x.value; return s === undefined || s === null ? JSON.stringify(x) : String(s) }
        return String(x)
    }
    if (Array.isArray(v)) return cut(v.map(one).filter((s) => s !== '').join(', '))
    return cut(one(v))
}
// cgColTitle: подпись колонки — title_<язык>, иначе t(title), иначе binding
export function cgColTitle(col, lang, t) {
    const tr = typeof t === 'function' ? t : (s) => s
    const own = col && lang ? col[`title_${lang}`] : ''
    if (typeof own === 'string' && own) return own
    return col && typeof col.title === 'string' && col.title ? String(tr(col.title)) : String((col && col.binding) || '')
}
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040, проба dev02 r8 D5b): у строки плоской таблицы ссылки AttrRowLink хранят только ключ ({node: {name: 'kam'}}), title не пишется — грид показывает его
// живым из строки-источника (rows_binding: doc.nodes / doc.fields / doc.horizons). Поле «Назва» (node.title / field.title) блока читалось getPath из строки — пусто.
// cgRowLinkText(col, row, record, lang, t, cache): колонка AttrRowLink — текст листа как в гриде (title — название строки-источника, «Not found: …», key — ключ); не AttrRowLink — null
export function cgRowLinkText(col, row, record, lang, t, cache) {
    if (!isObj(col) || col.attr_type !== RL_TYPE || !isObj(record)) return null
    const { cfg, errors } = rlConfig(col)
    if (errors.length) return null
    const sk = [cfg.rows_binding, cfg.key_binding, cfg.title_binding, cfg.children_path].join('|')
    let idx = cache ? cache.get(sk) : null
    if (!idx) { idx = rlItems(getPath(record, cfg.rows_binding), cfg, lang).index; if (cache) cache.set(sk, idx) }
    return cut(rlShown(row, cfg, idx, t).text)
}
// cgCardFields: поля строки по колонкам грида → [{ binding, title, text }] (не больше CG_CARD_MAX_FIELDS); грида нет — простые поля строки (без служебных, вложенных таблиц и объектов-описаний)
// record — запись виджета: колонки AttrRowLink показывают название строки-источника (p040)
export function cgCardFields(gridDecl, row, lang, t, lookup, record) {
    if (!isObj(row)) return []
    let cols = cgGridColumns(gridDecl)
    if (!cols.length) {
        cols = Object.keys(row).filter((k) => !k.startsWith('_') && !k.startsWith('cg_') && !k.includes('-') && !Array.isArray(row[k]) && !isObj(row[k])).map((k) => ({ binding: k, title: k }))
    }
    const rl = new Map()
    return cols.slice(0, CG_CARD_MAX_FIELDS).map((c) => {
        const link = cgRowLinkText(c, row, record, lang, t, rl)   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040)
        return { binding: c.binding, title: cgColTitle(c, lang, t), text: link !== null ? link : cgFieldText(getPath(row, c.binding), c, lang, t, lookup) }
    })
}
// cgRowLabel: подпись строки вкладки — узел / колонка по title_binding (на языке пользователя), иначе ключ; строка плоской таблицы — «узел × колонка»
export function cgRowLabel(key, targets, cfg, lang) {
    const nm = (row, tb) => (isObj(row) ? (localized(row, tb, lang) || String(getPath(row, cfg.key_binding) ?? '')) : '')
    const n = nm(targets.node && targets.node.row, cfg.rows_title_binding)
    const c = nm(targets.column && targets.column.row, cfg.columns_title_binding)
    if (key === 'node') return n
    if (key === 'column') return c
    return n && c ? `${n} × ${c}` : (n || c)
}
// cgCardNote: пояснение неактивной вкладки (t — перевод с подстановкой)
export function cgCardNote(reason, table, t) {
    const tr = typeof t === 'function' ? t : (s) => s
    if (reason === 'empty') return String(tr('No row in "{table}" for this cell yet: fill the cell to create it', { table }))
    if (reason === 'nokey') return String(tr('This cell is not tied to a row of "{table}": its row or column has no key', { table }))
    if (reason === 'title') return String(tr('Pick a cell of the matrix to see its row and column'))
    if (reason === 'gone') return String(tr('The row is not found in "{table}"', { table }))
    return ''
}
// cgCardsView: модель блока формы ячейки → { tabs: [{ key, title, ok, table, label, fields, note }] } в порядке CG_CARD_KEYS (вкладки «Рядок» во вложенном режиме нет)
export function cgCardsView(targets, cfg, { view, lang, t, lookup, record } = {}) {
    if (!targets || !cfg) return null
    const tr = typeof t === 'function' ? t : (s) => s
    const tabs = []
    for (const k of CG_CARD_KEYS) {
        const tg = targets[k]
        if (!tg) continue
        const grid = cg2FindGrid(view, tg.grid, tg.binding)
        const table = cg2TableTitle(grid, lang, tr, tg.binding)
        const ok = !!tg.row && !tg.reason
        tabs.push({ key: k, title: String(tr(CG_CARD_TITLES[k])), ok, table, label: ok ? cgRowLabel(k, targets, cfg, lang) : '',
            fields: ok ? cgCardFields(grid, tg.row, lang, tr, lookup, record) : [], note: ok ? '' : cgCardNote(tg.reason, table, tr) })   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040): + record — названия ссылок AttrRowLink
    }
    return { tabs }
}
// cgCardPick: активная вкладка — выбранная, если активна; иначе первая активная; активных нет — выбранная (или первая)
export function cgCardPick(tabs, want) {
    const list = arr(tabs)
    const w = list.find((x) => x.key === want)
    if (w && w.ok) return w.key
    const f = list.find((x) => x.ok)
    return f ? f.key : (w ? w.key : (list[0] ? list[0].key : ''))
}
// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040, проба dev02 r8 D5a): клик по НЕАКТИВНОЙ вкладке прежде молча подменялся первой активной (cgCardPick) — пояснение «fill the cell to create it» было недостижимо.
// cgCardClick(tabs, key) → { tab, off }: активная — выбрать её (off ''); неактивная — выбор не меняется (tab null), её пояснение показывается в блоке (off = key)
export function cgCardClick(tabs, key) {
    const tb = arr(tabs).find((x) => x.key === key)
    if (!tb) return { tab: null, off: '' }
    return tb.ok ? { tab: key, off: '' } : { tab: null, off: key }
}
// cgCardOffNote(tabs, off, cur): пояснение нажатой неактивной вкладки off; она же показана (cur — все вкладки неактивны, пояснение уже в карточке) или стала активной — ''
export function cgCardOffNote(tabs, off, cur) {
    if (!off || off === cur) return ''
    const tb = arr(tabs).find((x) => x.key === off)
    return tb && !tb.ok ? String(tb.note || '') : ''
}
// cgCardAction: действие стора — карточка строки widget-row (тот же набор, что AttrGraph.openRowWidget / граф схемы), справа от шахматки
export function cgCardAction(title, binding, attrs, selectedRow) {
    return { tooltip: title, action_name: 'action-front-openLine-graphRow-2026-09-06',
        widgetRow_params: { width_pct: 0.44, height_pct: 0.5, top_pct: 0.08, left_pct: 0.54 },
        command: 'widget_open', widget: 'widget-row', get_currentRow: true, get_Parent: true, open_in_children_widget: true, cssClass: 'pi p-button-white pi-pencil',
        source_attr_type: 'AttrCrossGrid', binding, attrs: Array.isArray(attrs) ? attrs : [], selectedRow }
}
